import axiosInstance from "shared/axios";
import {  MERCHANT_OFFER_V2,  MERCHANT_OFFER_MAP_V2_APIS} from "shared/constants";
import {queryparamBuilder} from 'shared/utils';
// Merchant Offer Map Listing 
export const fetchOfferMapListV2 = (selectedFilter,search,params) => {
    let uri = MERCHANT_OFFER_MAP_V2_APIS.listing;
    if (selectedFilter) {
      uri += `?search_cond=${selectedFilter}&search_terms=${search}&`;
    } else if (Object.keys(params).length) {
      uri += "?";
    }
    uri += queryparamBuilder(params);
    return axiosInstance.post(`${uri}`);
  };

export const fetchOfferMapViewDataV2 = (id) => {
  return axiosInstance.get(`/api/v2/transactions/promo-offer/${id}/offer-map-view`);
};
    
// export const fetchSetOfferDetails  = (id) => {
//         return axiosInstance.Patch(`api/v1/transactions/promo-offer/${id}/set-default-offer`);
//     };
       
// export const offerDropDwonList = (param) => {
//     let fullParam = param ? `${MERCHANT_OFFER_MAP_APIS.listing}${param}` : `${MERCHANT_OFFER_MAP_APIS.listing}`;
//     return axiosInstance.post(fullParam);
//     };

export const fetchOfferDropdownDataV2 = (data) => {
    let url = `${MERCHANT_OFFER_MAP_V2_APIS.dropdownData}`;
    return axiosInstance.post(url,data);
    };

export const onSubmitAddOfferMapDataV2 = (data) => {
    let url = `${MERCHANT_OFFER_MAP_V2_APIS.add}`;
    return axiosInstance.post(url,data);
    };
export const onSubmiEdittOfferMapDataV2 = (id,data) =>{
    let url = `${MERCHANT_OFFER_MAP_V2_APIS.update}/${id}/offer-map-update`;
    return axiosInstance.patch(url,data);
}
// Merchant Listing 
export const fetchOfferList = (param) => {
  let url = `${MERCHANT_OFFER_V2.listing}`;
    return axiosInstance.post(url,param);
};

export const fetchViewV2 = (offerReferenceNumber) => {
  let url = `${MERCHANT_OFFER_V2.view}/${offerReferenceNumber}/view`;
  return axiosInstance.get(url);
};

export const createApi = (param) => {
    let url = `${MERCHANT_OFFER_V2.create}`;
      return axiosInstance.post(url,param);
};
